__turbopack_context__.v({
  "article": "BrandsList-module-scss-module__sJIM4q__article",
  "article__image": "BrandsList-module-scss-module__sJIM4q__article__image",
  "content": "BrandsList-module-scss-module__sJIM4q__content",
  "elementsSlider": "BrandsList-module-scss-module__sJIM4q__elementsSlider",
  "root": "BrandsList-module-scss-module__sJIM4q__root",
  "slide": "BrandsList-module-scss-module__sJIM4q__slide",
});
